export default {
  common: {
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    copy: '复制',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '提示',
    requestError: '请求错误',
    authFailed: '认证失败，请重试',
    networkError: '网络错误，换个网络试试',
    today: '今天',
    tomorrow: '明天',
    noData: '暂无更多数据',
    submit: '提交',
    or: '或',
    switch: '切换',
    linkCopied: '链接已复制',
    month: '月',
    day: '日',
    start: '开始',
    end: '结束',
    startEnd: '开始/结束',
    view: '查看',
    yearsOld: '岁',
    switchLanguageTo: '切换语言为',
    sunday: '周日',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    about: '约',
    from: '起',
    fromPerNight: '起/晚',
    loadFailed: '加载失败',
    // 日期格式
    dateFormat: 'MM月DD日',
    shortDateFormat: 'MM-DD',
    // 星期数组用于日期格式化
    weekdayShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    dateWithWeekday: 'MM月DD日 dddd',
  },
  hotel: {
    roomDetails: '房间详情',
    checkIn: '入住',
    checkOut: '离店',
    nights: '晚',
    totalNights: '共{count}晚',
    price: '价格',
    totalPrice: '总价',
    totalPriceWithTaxes: '总价(含税/费)',
    cancelPolicy: '取消政策',
    refundable: '可退款',
    nonRefundable: '不可退款',
    partiallyRefundable: '收费取消',
    freeCancel: '限时免费取消',
    paidCancel: '收费取消',
    checkInTime: '入住时间',
    checkOutTime: '离店时间',
    checkInCheckOutTime: '入离时间',
    selectCheckInCheckOutDate: '选择入住离店日期',
    after: '以后',
    before: '以前',
    contactHotelForCheckIn: '请与酒店联系确认入住时间',
    contactHotelForCheckOut: '请与酒店联系确认离店时间',
    guestInfo: '入住人信息',
    guest: '入住人',
    firstName: '名',
    lastName: '姓',
    phone: '手机号',
    email: '电子邮箱',
    adults: '成人',
    children: '儿童',
    bedType: '床型',
    bedPreference: '床型偏好',
    roomType: '房型',
    facilities: '设施',
    amenities: '便利设施',
    breakfast: '早餐',
    noBreakfast: '无早餐',
    paymentMethod: '支付方式',
    payNow: '现在付款',
    payAtHotel: '到店付款',
    submitOrder: '提交订单',
    orderConfirmation: '订单确认',
    bookingDetails: '预订详情',
    priceDetails: '价格明细',
    taxes: '税费',
    fees: '费用',
    additionalFees: '附加费用',
    mandatoryFees: '额外费用',
    resortFees: '度假费用',
    taxInfo:
      '这一费用包括旅行服务提供商(例如酒店、汽车租赁公司)为其应缴税款而支付的预估金额，以及/或者我们根据您的预订向费用、清洁费以及其他费用，以及/或者我们、酒店供应商或您所预订的网站作为对我们和/或他们服务的补偿而保留的费用，这部分费用因地点、金额以及预订方式等因素而异。',
    paymentIncomplete: 'PayPal付款未完成',
    paymentFailed: '支付失败',
    paymentSuccess: '支付成功',
    pleaseCompletePayment: '请登录您的PayPal账号并完成付款',
    loginPaypal: '登录PayPal账号付款',
    paypalInfo: 'PayPal支付说明',
    paypalDesc1: '登录界面将在新窗口中打开',
    paypalDesc2: '登录您的PayPal账号并完成付款',
    paypalDesc3: '支付成功后，你将获得订单确认',
    readBeforeBooking: '订房必读',
    mustRead: '订房必读',
    agreementAndTerms: '条款和协议',
    iAgree: '提交代表您同意',
    supplierTerms: '《供应商条款和协议》',
    roomsCount: '间',
    averagePricePerNight: '每间每晚平均价',
    dailyPriceDetails: '每日价格详情',
    onlinePayment: '在线付',
    paymentDetails: '支付明细',
    currency: '货币',
    exchangeRate: '汇率',
    estimatedPrice: '估价',
    priceChangeWarning: '*此价格是基于当前汇率的估价，入住时可能会有变化。',
    hotelName: '酒店名称',
    address: '地址',
    copyAddress: '复制',
    addressCopied: '复制成功',
    contact: '联系方式',
    callHotel: '拨打酒店',
    emailHotel: '邮件酒店',
    specialRequests: '特殊要求',
    noSpecialRequests: '无特殊要求',
    policies: '政策',
    checkInPolicy: '入住政策',
    checkOutPolicy: '离店政策',
    petPolicy: '宠物政策',
    childrenPolicy: '儿童政策',
    groupPolicy: '人群接待政策',
    accessMethod: '进入方式',
    specialInstructions: '特殊说明',
    knowBeforeYouGo: '出行前须知',
    onSitePayments: '现场付款',
    paymentOptions: '支付选项',
    acceptedCards: '接受的卡类',
    hotelInfo: '酒店信息',
    openingTime: '开业时间',
    roomCount: '房间数量',
    hotelRating: '酒店星级',
    hotelPhone: '酒店电话',
    hotelHighlights: '酒店亮点',
    bookingRules: '预定须知',
    importantTips: '重要提示',
    facilityServices: '设施服务',
    hotelIntroduction: '酒店介绍',
    hotelDescription: '酒店描述',
    otherAmenities: '此酒店提供的其他礼遇包括',
    roomFeatures: '客房特色',
    otherFacilitiesServices: '其他的设施/服务还包括',
    hotelPolicies: '酒店政策',
    checkInStart: '开始办理入住',
    checkInEnd: '停止办理入住',
    checkOutBefore: '之前退房',
    pets: '宠物',
    childrenAndBeds: '儿童及加床',
    paymentMethods: '付款方式',
    needToKnow: '您需知道',
    otherNotes: '其他注意事项',
    otherItems: '其他项目',
    hotelFacilities: '酒店设施',
    noFacilityInfo: '暂无设施信息',
    viewRoomTypes: '查看房型',
    noPhone: '暂无电话',
    guestMinAge: '住客需年满',
    minimumCheckInAge: '最低入住年龄',
    yearsOld: '岁',
    rooms: '间',
    acceptedPayments: '接受的支付方式',
    guestInfoTip: '请填写所有入住人的姓名信息',
    invalidPhone: '请输入正确的手机号',
    invalidEmail: '请输入正确的电子邮箱',
    nameCannotContainChinese: '姓名不能包含中文，请使用拼音或英文',
    nameOnlyEnglish: '姓名只能包含英文字母',
    pleaseEnterName: '请输入姓名',
    pleaseEnterPhone: '请输入联系手机号',
    pleaseEnterEmail: '请输入电子邮箱',
    completeGuestInfo: '请完善入住人信息',
    priceChanged: '价格变动，请重新下单',
    networkError: '网络异常，请重新下单',
    bookingFailed: '预订失败',
    bookingSuccess: '预订成功',
    orderCreated: '订单创建成功',
    paymentCancelled: '已取消支付',
    paymentError: '支付错误',
    tryAgain: '重试',
    goToOrders: '查看订单',
    goToHome: '返回首页',
    noRooms: '暂无房间',
    selectRoom: '选择房间',
    selectDate: '选择日期',
    selectGuests: '选择入住人',
    search: '搜索',
    searchHotels: '搜索酒店',
    noResults: '未找到结果',
    tryDifferentSearch: '尝试不同的搜索',
    loadMore: '加载更多',
    noMore: '没有更多了',
    retry: '重试',
    close: '关闭',
    // 房间选择相关
    room: '房间',
    selectRoomsAndGuests: '选择客房与入住人数',
    selectChildAge: '选择儿童',
    adultsCount: '成人数',
    childrenCount: '儿童数',
    selectChildAgeInfo: '请选择每位儿童年龄，以便为您选择合适的客房和床型，可能还有特价优惠',
    child: '儿童',
    underOneYear: '1岁以下',
    ageRequired: '年龄为必选',
    selectAge: '选择年龄',
    deleteRoom: '删除客房',
    addAnotherRoom: '添加另一间客房',
    pleaseSelectBedPreference: '请选择床型偏好',
    bedPreferenceNotGuaranteed: '无法保证满足床型要求，请联系酒店进行确认',
    selectPreference: '选择偏好',
    total: '共',
    // 酒店列表相关
    hotelList: '酒店列表',
    noHotelsFound: '非常抱歉，没有为您找到的相关酒店，请重新输入',
    soldOutChangeTime: '该时间已售罄，请更换时间或酒店查询',
    roomsLeft: '仅剩',
    book: '订',
    quickBook: '抢',
    bookNow: '立即预订',
    // 房间详情相关
    specialCheckInInstructions: '特殊入住说明',
    childrenAndExtraBeds: '儿童及加床',
    importantNotes: '重要提示',
    noBookingInfo: '暂无订房必读信息',
    hasWifi: '有 WIFI',
    noWifi: '无WIFI',
    freeParking: '免费停车',
    guests: '人',
    accommodates: '可入住',
    floor: '层',
    roomFacilities: '房间服务设施',
    noFacilitiesInfo: '暂无设施信息',
    roomRateDetails: '房费明细',
    noCancelPolicy: '暂无取消政策',
    avgPricePerRoomPerNight: '每间每晚平均价格',
    zeroRooms: '0间',
    searchPlaceholder: '目的地、住宿、或者地标',
    searchResults: '查询结果',
    noSearchResults: '很抱歉，当前搜索条件无符合结果',
    // 填单页面新增
    pinyinOrEnglish: '拼音或英文',
    pleaseEnterLastName: '请输入姓',
    pleaseEnterFirstName: '请输入名',
    noChineseOrNumbers: '不能包含中文数字',
    roomNumber: '房间{number}',
    companionsCannotCheckIn: '随行人员无法发起办理入住手续',
    orderPayment: '订单支付',
    pleaseCompletePaymentWithin: '请在',
    completePayment: '内完成支付',
    reorderWarning: '重新预订可能涨价或者没房哦！',
    guestName: '入住人',
    meals: '餐食',
    includingTaxesAndFees: '含税和费用',
    pleaseEnterContactPhone: '请输入联系手机号',
    pleaseEnterValidPhone: '请输入正确的手机号',
    emailForItinerary: '用于接收行程单',
    pleaseEnterValidEmail: '请输入正确的电子邮箱',
    roomsAndNights: '{rooms}间 X {nights}晚',
    paidCancellation: '收费取消',
    limitedFreeCancellation: '限时免费取消',
    resortFee: '度假费用',
    otherFees: '其他费用',
    otherFeesTotal: '其他费用总计',
    submitAgreement: '提交代表您同意',
    paypalLoginNewWindow: '登录界面将在新窗口中打开',
    paypalLoginAndPay: '登录您的PayPal账号并完成付款',
    paypalSuccessConfirmation: '支付成功后，你将获得订单确认',
    additionalTax: '额外税款',
    priceEstimateNote: '*此价格是基于当前汇率的估价，入住时可能会有变化。入住时可能会有变化。',
    paymentConfirming: '付款确认中',
    doNotClosePage: '请勿关闭页面...',
    paypalPaymentIncomplete: 'PayPal付款未完成。',
    beforeCheckOut: '前离店',
    afterCheckIn: '后入住',
    noMeals: '无餐食',
    noMealInfo: '无相关餐食信息',
    loginPaypalToPay: '登录PayPal账号付款',
    completePaymentWithin: '请在',
    rebookingMayIncrease: '重新预订可能涨价或者没房哦！',
    priceChangedReorder: '价格变动，请重新下单',
    networkErrorReorder: '网络异常，请重新下单',
    taxDescription: '税费说明',
    taxInfoTip:
      '这一费用包括旅行服务提供商(例如酒店、汽车租赁公司)为其应缴税款而支付的预估金额，以及/或者我们根据您的预订向费用、清洁费以及其他费用，以及/或者我们、酒店供应商或您所预订的网站作为对我们和/或他们服务的补偿而保留的费用，这部分费用因地点、金额以及预订方式等因素而异。',
    age: '年龄',
    priceCheckFailed: '房价查询失败，请重新搜索',
    priceAbnormal: '价格异常',
    priceCheckError: '房价查询异常，请重新搜索',
    popupOpenedInitPaypal: '弹窗打开，初始化 PayPal 按钮',
    noPendingOrderId: '没有待支付的订单号',
    copySuccess: '复制成功',
    getOpenidFailed: '获取 openid 失败',
    bedTypeNotSpecified: '未指定床型',
    pleasePayInExternalBrowser: '请在外部浏览器中完成支付',
    paymentPageOpened: '已打开支付页面，请完成支付',
    getPaymentLinkFailed: '获取支付链接失败',
    paymentFailedRetry: '支付失败，请重试',
    preparingPayment: '正在准备支付...',
    payWithOpenid: '使用 openid 进行支付',
    getPaymentParamsFailed: '获取支付参数失败',
    invokingPayment: '正在唤起支付...',
    userCancelledPayment: '用户取消支付',
    paymentErrorRetry: '支付异常，请重试',
    wechatPaymentError: '微信支付异常',
    initPaypalButton: '初始化 PayPal 按钮，订单号',
  },
  order: {
    myOrders: '我的订单',
    orderDetails: '订单详情',
    orderNumber: '订单号',
    orderDate: '订单日期',
    orderStatus: '订单状态',
    pending: '待确认',
    confirmed: '已确认',
    cancelled: '已取消',
    completed: '已完成',
    refunding: '退款中',
    refunded: '退款成功',
    paymentPending: '待支付',
    paymentConfirmed: '已支付',
    toPay: '待支付',
    toTravel: '待出行',
    cancelBooking: '取消预订',
    rebook: '再次预订',
    viewDetails: '查看详情',
    refundAmount: '退款金额',
    refundStatus: '退款状态',
    applyRefund: '申请退款',
    refundPolicy: '退款政策',
    noOrders: '暂无订单',
    startBooking: '开始预订',
    timeRemaining: '剩余时间',
    remainingTimePending: '剩余 {time} 待支付',
    minutesRemaining: '分钟内完成支付',
    paymentExpired: '支付已过期',
    cancelConfirm: '确定要取消此预订吗？',
    cancelSuccess: '预订取消成功',
    cancelFailed: '取消预订失败',
    refundSuccess: '申请退款成功',
    refundFailed: '申请退款失败',
    searchOrders: '搜寻订单',
    // 取消原因相关
    cancelReason: '取消原因',
    personalReason: '我不想去了、个人原因无法出行',
    changeTravelDate: '需更改出行日期',
    planChanged: '计划有变不去了',
    otherReason: '其他原因',
    additionalDescription: '补充描述',
    enterDescription: '请输入问题描述~',
    cancelReasonRequired: '取消原因不能为空',
    // 订单状态
    statusConfirming: '确认中',
    statusPaying: '待支付',
    statusChecking: '待出行',
    statusCompleted: '已完成',
    statusCanceled: '已取消',
    paidCancellation: '收费取消',
    limitedFreeCancellation: '限时免费取消',
    hotelType: '酒店',
    totalNights: '共{count}晚',
    roomDetails: '房间详情',
    roomNumber: '房间{number}',
    adultsCount: '{count}位成人',
    childrenCount: '{count}位儿童',
    // 取消订单相关
    cancelWarning: '取消预订可能会根据取消政策中规定 扣除对应费用，请谨慎操作',
    refundApplicationSubmitted: '已提交退款申请',
    applicationSubmitted: '已提交申请',
    verificationFailed: '验证失败，请重新验证',
    // 订单详情页
    pleaseCompletePaymentWithin: '请在',
    completePayment: '内完成支付',
    rebookingWarning: '重新预订可能涨价或者没房哦',
    orderSubmitted: '您的订单已提交，正在等待酒店确认',
    roomConfirmationNumber: '房间{number}确认号',
    details: '详情',
    viewCancelPolicy: '查看',
    viewBookingInfo: '查看入住说明、特别说明、费用说明等',
    viewRefundInfo: '查看退款信息',
    refundToPaypalAccount: '退款至您的PayPal账户',
    refundedStatus: '已退款',
    paymentInfo: '付款信息',
    viewPaymentInfo: '查看付款信息',
    totalFees: '总费用',
    paidFees: '已付款费用',
    paymentSuccessful: '支付成功',
    paymentDeducted: '我们已对此订单扣款成功',
    viewOrders: '可以在"我的订单"查看',
    orderInfo: '订单信息',
    orderTime: '下单时间',
    paymentTime: '支付时间',
    saveReceipt: '保存收据',
    cancelOrder: '取消订单',
    cancelOrderTitle: '您需要取消订单',
    cancelOrderDesc: '您即将取消整个预订，取消前请先查看下方信息',
    refundDetails: '退款详情',
    unpaidCancelNote: '此订单尚未付款。取消后不会收取任何费用。',
    confirmCancel: '确定取消',
    cancelRules: '取消规则',
    noPolicyAvailable: '暂无政策',
    missingParameters: '缺少必要参数',
    getRoomDetailFailed: '获取房间详情失败',
    roomDetailIncomplete: '房间详情数据不完整',
    emailSentSuccess: '发送邮件成功',
    emailSentFailed: '发送邮件失败',
    taxFeeDescription:
      '这些税款是支付给供应商（e.g. 酒店）的税收回收费用；详情请参阅我们的使用条款。服务费是为您提供预订服务的补偿，其中可能包括供应商收取的费用',
    taxFeeTitle: '税费说明',
    copyFailed: '复制失败',
    copySuccess: '复制成功',
    includingTaxesAndFees: '含税和费用',
    payAtHotelNote: '到店支付',
    mandatoryFeesNote: '额外费用',
    resortFeesNote: '度假费用',
    additionalTaxNote: '额外税款',
    ageYears: '{age}岁',
    lookingForwardToNextVisit: '期待您下次光临！',
    cancelSuccessful: '取消成功',
  },
  user: {
    login: '登录',
    logout: '退出登录',
    register: '注册',
    profile: '个人中心',
    settings: '设置',
    language: '语言',
    currency: '币种',
    selectLanguage: '选择语言',
    selectCurrency: '选择币种',
    currencyDesc:
      '适用价格将转换为你所选的货币并以该货币显示。支付时所使用的货币可能根据你的预订而有所不同，且还可能产生服务费。',
    myInfo: '我的信息',
    editInfo: '编辑信息',
    avatar: '头像',
    nickname: '昵称',
    phone: '手机号',
    email: '邮箱',
    address: '地址',
    city: '城市',
    country: '国家',
    postalCode: '邮编',
    about: '关于',
    help: '帮助',
    contactUs: '联系我们',
    faq: '常见问题',
    termsAndConditions: '条款和条件',
    privacyPolicy: '隐私政策',
    supplierTerms: '供应商条款和协议',
    userAgreement: '用户协议',
    logoutConfirm: '确定要退出登录吗？',
    logoutSuccess: '退出登录成功',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    registerSuccess: '注册成功',
    registerFailed: '注册失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    welcome: '您好，旅行者！',
    slogan: '爱游会，优质酒店尽在其中',
    switchToChinese: '切换到中文',
    switchToEnglish: 'Switch to English',
    loginStatus: '登录状态',
    notLoggedIn: '未登录',
  },
  login: {
    title: '登录/注册',
    authLogin: '授权登录',
    recentAuthorized: '近期您已经授权以上账号登录过爱游会点击确认可自动登录',
    slogan: '登录注册查看更多优质酒店',
    phoneShortcut: '手机号快捷登录',
    loginNow: '立即登录',
    lastLoggedIn: '上次登录过',
    useOtherPhone: '使用其他手机号码登录',
    accountLogin: '账号登录',
    enterAccount: '请输入账号',
    enterPassword: '请输入登录密码',
    forgetPassword: '忘记密码?',
    phoneCodeLogin: '手机验证码登录',
    welcome: '欢迎登录/注册',
    enterPhone: '请输入手机号',
    enterCode: '输入验证码',
    getCode: '获取验证码',
    resetPassword: '重置密码',
    setNewPassword: '请设置新密码',
    passwordTip: '密码需为8-18位字母、数字和符号的组合，不含空格',
    complete: '完成',
    agreePrefix: '我已阅读同意',
    serviceAgreement: '《平台服务协议》',
    agreeSuffix: '，如果您的手机未注册，登录的时候将为您自动注册',
    readAndAgree: '请阅读并同意嗨行平台的',
  },
  home: {
    home: '首页',
    welcome: '欢迎',
    searchHotels: '搜索酒店',
    destination: '目的地',
    checkIn: '入住',
    checkOut: '离店',
    guests: '入住人',
    guestCount: '{count}位旅客',
    rooms: '房间',
    roomCount: '{count}间客房',
    search: '搜索',
    hotDeals: '热门优惠',
    popularDestinations: '热门目的地',
    recentSearches: '最近搜索',
    clearHistory: '清除历史',
    noRecentSearches: '暂无最近搜索',
    featured: '精选',
    recommendations: '推荐',
    viewAll: '查看全部',
    seeMore: '查看更多',
  },
  payment: {
    paypal: 'PayPal',
    creditCard: '信用卡',
    debitCard: '借记卡',
    wechat: '微信支付',
    alipay: '支付宝',
    bankTransfer: '银行转账',
    selectPaymentMethod: '选择支付方式',
    paymentMethod: '支付方式',
    cardNumber: '卡号',
    expiryDate: '有效期',
    cvv: 'CVV',
    cardholderName: '持卡人姓名',
    billingAddress: '账单地址',
    sameAsShipping: '与收货地址相同',
    paymentProcessing: '支付处理中',
    paymentConfirming: '确认支付中',
    doNotClose: '请勿关闭此页面',
    paymentSuccessful: '支付成功',
    paymentFailed: '支付失败',
    paymentCancelled: '支付已取消',
    tryAgain: '重试',
    returnToOrder: '返回订单',
    refund: '退款',
    refundProcessing: '退款处理中',
    refundSuccessful: '退款成功',
    refundFailed: '退款失败',
    // 支付组件相关
    cashier: '收银台',
    scanToPay: '扫一扫付款',
    paymentCompleted: '我已完成支付',
    wechatPay: '微信支付',
    alipayPay: '支付宝支付',
    amountToPay: '待支付金额：',
    scanWithWechat: '请用微信扫码支付',
    scanWithAlipay: '请用支付宝扫码支付',
    skipPayment: '暂不支付',
    confirmPaymentComplete: '请确认支付是否已完成',
    retryPayment: '支付遇到问题，重新支付',
  },
  // 表单相关
  form: {
    name: '姓名',
    enterName: '请输入姓名',
    nameRequired: '请填写姓名',
    phoneNumber: '手机号码',
    enterPhoneNumber: '请输入手机号码',
    phoneRequired: '请填写手机号码',
    documentInfo: '证件信息',
    identity: '身份',
    optionalButRequired: '选填，购买门票时必填',
    idCard: '身份证',
    idCardRequired: '请填写身份证',
  },
  // 退款相关
  refund: {
    process: '退款流程',
    submitApplication: '发起退款申请',
    success: '退款成功',
    failed: '退款失败',
    notRefunded: '未退款',
    processing: '退款中',
  },
  // 页面标题相关
  page: {
    contactUs: '联系我们',
    selectDestination: '选择目的地',
    supplierTerms: '供应商条款和协议',
    privacyPolicy: '隐私协议',
    travelers: '出行人',
    selectContact: '选择联系人',
    payment: '支付',
    my: '我的',
    settings: '设置',
    hotelList: '酒店列表',
    userAgreement: '用户协议',
    noTravelers: '暂无出行人',
    addTraveler: '添加出行人',
    noInvoice: '暂无报销凭证',
    selectRoomAndGuests: '选择房间和客人',
  },
  // 搜索相关
  search: {
    historyDetected: '检测到历史搜索记录',
    requestReturned: '请求回来',
    saved: '保存的',
    history: '历史搜索',
    clearHistory: '确定清除历史记录？',
    tip: '提示',
  },
  // 定位相关
  location: {
    final: '定位最终',
    beijing: '北京',
    beijingPalaceMuseum: '北京故宫博物馆',
  },
  // 应用相关
  app: {
    name: '嗨行旅游',
  },
  // Tabbar 相关
  tabbar: {
    home: '首页',
    my: '我的',
  },
  // 数字相关
  number: {
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '七',
    eight: '八',
  },
  // 年龄相关
  age: {
    underOne: '1岁以下',
    oneYear: '1岁',
    twoYears: '2岁',
    threeYears: '3岁',
    fourYears: '4岁',
    fiveYears: '5岁',
    sixYears: '6岁',
    sevenYears: '7岁',
    eightYears: '8岁',
    nineYears: '9岁',
    tenYears: '10岁',
    elevenYears: '11岁',
    twelveYears: '12岁',
    thirteenYears: '13岁',
    fourteenYears: '14岁',
    fifteenYears: '15岁',
    sixteenYears: '16岁',
    seventeenYears: '17岁',
    eighteenYears: '18岁',
  },
  // 错误提示相关
  error: {
    maxGuestsReached: '已达到最大入住人数（20人）',
    maxGuestsPerRoom: '单间客房最多16人',
    maxRoomsReached: '最多只能添加8间客房',
    noHotelsFoundRecommendation:
      '很抱歉，暂未找到符合要求的酒店信息，已为您自动推荐您最近查看过的目的地，方便您继续预订',
    checkOutDateInPast: '离店日期不能在今天之前，已自动更新',
  },
  // 调试相关
  debug: {
    hello: '你好',
    requestingApple: '正在请求苹果服务器',
    userPaymentSuccess: '用户支付成功',
    userCancelPayment: '用户取消支付',
    checkingMissedOrders: '正在查询是否有漏单信息',
    missedOrderResult: '漏单查询结果：',
    noMissedOrders: '未漏单',
    hasMissedOrders: '有漏单',
    processingPaymentResult: '正在处理支付结果...',
  },
  // 图片相关
  image: {
    saveImage: '保存图片',
    saveSuccess: '保存成功',
  },
  // 交易详情相关
  transaction: {
    title: '交易详情',
    paid: '已支付',
    viewRefundHistory: '查看退款历史',
    transactionDetails: '交易详情',
    refundStartedAt: '退款开始于',
    transactionDate: '交易日期',
    processor: '处理方',
    processorName: '好旅由.com',
    paymentMethod: '支付方式',
    refundHistory: '退款历史',
    refundCompleted: '已完成退款。',
    refundCompletedAt: '{date}已退款',
    refundStartedAtDate: '{date}开始退款',
    refundProcessingTime: '通常需要7-12个日历天完成退款。',
    processingRefund: '我们正在处理您的退款',
    processingRefundDesc: '我们将退款金额通过原来的支付方式发放后，您可在此处查看进度。',
    refundReceived: '您已收到退款',
    refundReceivedDesc: '退款已按您原来的支付方式退还给您',
    // 退款状态
    statusUnrefund: '未退款',
    statusRefunding: '正在取消中',
    statusRefunded: '取消成功',
    statusRefundFailed: '取消失败',
  },
  // 邮箱验证相关
  emailVerify: {
    searchOrders: '搜索订单',
    step1Label: '1.请输入您预订时所使用的电子邮箱地址，我们将向您收取验证码',
    emailPlaceholder: '电邮',
    getCode: '获取验证码',
    resend: '重新发送',
    resendCountdown: '重新发送{count}s',
    step2Label: '2.请检查您的电邮，并在下方输入邮箱内的6位数验证码',
    codePlaceholder: '验证码',
    pleaseEnterEmail: '请输入邮箱地址',
    pleaseEnterValidEmail: '请输入正确的邮箱地址',
    codeSent: '验证码已发送，请查收邮箱',
    sendFailed: '发送失败，请重试',
  },
  errorPage: {
    errorOccurred: '抱歉，我们遇到了一些问题',
  },
}
